import { IRecord } from 'interfaces';

import { isServerSide } from './environment';

export function carryParams(route: string, extra?: { [key: string]: string | number }) {
  const existingURLParams = new URLSearchParams(window.location.search);

  // we want to have this param only once
  existingURLParams.delete('trigger');

  if (extra) {
    Object.entries(extra).forEach(([key, val]) => {
      if (val) {
        return existingURLParams.set(key, val.toString());
      } else {
        return existingURLParams.delete(key);
      }
    });
  }

  const params = existingURLParams.toString();
  return `${route}${params ? `?${params}` : ''}`;
}

export const doItemsMatch = (left: IRecord, right: IRecord) => {
  const idsMatch = left?.id === right?.id;
  const titlesMatch = left?.title === right?.title;
  const characterIndexMatch = left?.characterIndex === right?.characterIndex;

  return idsMatch && titlesMatch && characterIndexMatch;
};

export const humanFileSize = (size: number): string => {
  const i = Math.floor(Math.log(size) / Math.log(1024));
  const sizeValue = (size / Math.pow(1024, i)).toFixed(2);
  return sizeValue + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
};

export const isItemPage = () => {
  return !isServerSide() && new URL(document.location.href).pathname.indexOf('item') > -1;
};

export const playbackSpeedToUpperTen = (playbackSpeed: number = 1.2) => {
  return Math.ceil(playbackSpeed * 20) / 20;
};

export function sortBy(key: string) {
  return (a: $TSFixMe, b: $TSFixMe) => (a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0);
}

// Utility function to ensure URLs have a protocol prefix
export function ensureFullUrl(input: string): string {
  // Trim whitespace and check if the URL starts with 'http://' or 'https://'
  const trimmedInput = input.trim();
  const hasProtocol = /^(http:\/\/|https:\/\/)/i.test(trimmedInput);

  return hasProtocol ? trimmedInput : `https://${trimmedInput}`;
}

export const sleep = (ms: number) => new Promise<void>(r => setTimeout(() => r(), ms));
